<p-dropdown
  [filter]="true"
  [options]="expertSearchOptions"
  [(ngModel)]="selectedExpertSearchOption"
  (onChange)="onExpertSearchChange($event)"
  [style]="{'width': '100%'}"
  appendTo="body"
  placeholder="---"
></p-dropdown>
